module.exports = __webpack_public_path__ + "static/img/becomeExpert.f72b9e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/becomeExpert.png
// module id = U/kC
// module chunks = 101